module.exports = __webpack_public_path__ + "static/media/Yoshilogo1.d35d41c3.png";